import { MoreVert } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Gene20Box from "../../Components/Gene20Box/Gene20Box";
import catalogueData from "../../routes/data/catalogueRoutesData";

export default function BuyAndSell() {
  const useStyles = makeStyles((theme) => ({
    catalogues: {
      // padding: "2vh",
    },
  }));
  const classes = useStyles();
  return (
    <Gene20Box sx={{ width: "100%" }}>
      <Grid container spacing={2}>
        {catalogueData.map((cater) => (
          <Grid item xs={12} sm={4} sx={{ mb: "2vh" }}>
            <Card sx={{ padding: "1vh" }}>
              {/* <CardHeader
                avatar={
                  <Avatar aria-label="recipe" sx={{ backgroundColor: "red" }}>
                    {cater.avatar}
                  </Avatar>
                }
                action={
                  <IconButton aria-label="settings">
                    <MoreVert />
                  </IconButton>
                }
                title={cater.name}
              /> */}
              <Typography variant="title" color="primary">
                {cater.name}
              </Typography>
              <CardMedia
                component="img"
                height="194"
                image={cater.image}
                alt="Paella dish"
              />
              <CardActions>
                <Button variant="contained">view More</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Gene20Box>
  );
}
